import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const exclusivePublicSizeCalcEnabled = !!getFeature('exclusivePublicSizeCalcEnabled');
